import type { ScreenModule } from "../../../app/screen-module";
import { LandingPage } from "../LandingPage";

export default {
	id: "public.landing",
	path: "/",
	area: "public",
	label: "サービスLP",
	roles: [],
	backing: "MOCK_ONLY",
	enabled: true,
	component: LandingPage,
} satisfies ScreenModule;
